import { Svg } from './Svg';
import { KeyboardClickable } from './KeyboardClickable';

import PropTypes from 'prop-types';
import React from 'react';

/* global getTrackingLink */

export let NextdoorGenericLink = function ({
    className,
    urlToShare,
    shareBody,
    supportForName,
    pageName,
    onNextdoorClick,
}) {
    function getNextdoorUrl() {
        const intro = shareBody || `Hi! I'm a neighbor here looking to ${supportForName}: `;
        const body = encodeURIComponent(intro);
        const paramLinks = getTrackingLink(urlToShare, 'nextdoor', pageName);
        return `https://nextdoor.com/sharekit/?source=DonorsChoose&hashtag=fundraising&body=${body}` + paramLinks;
    }

    function onClick(event) {
        dcAnalytics.trackShareToolClick(pageName, urlToShare, 'Nextdoor', false);
        return onNextdoorClick(event, getNextdoorUrl());
    }

    return (
        <KeyboardClickable>
            <a tabIndex="0"
                onClick={onClick}
                aria-label="Share on Nextdoor"
                className={className + ' heap-nextdoor-share small button-secondary'}>
                <Svg icon="ss-nextdoor" iconFamily="social-circle"/> Nextdoor
            </a>
        </KeyboardClickable>
    );
};

NextdoorGenericLink.propTypes = {
    urlToShare: PropTypes.string.isRequired,
    shareBody: PropTypes.string,
    supportForName: PropTypes.string,
    pageName: PropTypes.string,
    className: PropTypes.string,
    onNextdoorClick: PropTypes.func.isRequired,
};

NextdoorGenericLink = React.memo(NextdoorGenericLink);
